import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import {
  getLedgerType,
  updateLedgerType,
} from "../../services/roomLedgerTypeService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";

class RoomTypeEditForm extends Form {
  state = {
    data: {
      name: "",
    },
    errors: {},
  };

  schema = {
    name: Joi.string().required().label("Ledger type"),
  };

  async populateLedgerType() {
    try {
      const ledgerTypeId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: ledgerType } = await getLedgerType(ledgerTypeId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(ledgerType) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateLedgerType();
  }

  mapToViewModel(ledgerType) {
    return {
      name: ledgerType.name,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });
      await updateLedgerType(data);
      this.setState({ blocking: false });
      toast.success("Ledger type has been updated successfully.");
      this.props.history.push("/rooms-ledgers-types");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
      return "Your are authorized to perform this action.";
    }
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/room.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update room ledger type</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/rooms-ledgers-types")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update room ledger type</h3>
              <p>Provide the information below to update the ledger type.</p>
              {this.renderInput("name", "Ledger type", "text")}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default RoomTypeEditForm;
